'use client'

import { CrossChainPage } from '@/containers/CrossChain'

export default function Page() {
  return <CrossChainPage />
}
